var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (_vm.stickyBuynowButton && _vm.smallScreen && _vm.oneVariant) ||
    (_vm.stickyBuynowButton && !_vm.smallScreen && (_vm.oneVariant || !_vm.oneVariant)) ||
    !_vm.stickyBuynowButton
  )?_c('button',_vm._b({staticClass:"cta cta--light",attrs:{"id":"mikmak-button","data-mm-ids":_vm.productId,"data-mm-wtbid":_vm.mikmakWidgetId,"data-mm-sticky":_vm.mikmakStickyButton,"aria-label":_vm.labelText,"data-mm-id-type":"gtin"},on:{"click":function($event){_vm.handleBuyNowClick(_vm.productName, _vm.productId),  _vm.ddxOn()}}},'button',_vm.additionalProp,false),[_c('span',[_vm._v(_vm._s(_vm.labelText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }